import type { IColumn } from 'shared/ui/TableNew'
import type { RowContactsComparison } from 'entities/Analytics/model/Table/RowContactsComparison'
import { type SearchTypesEnum } from 'widgets/SearchDropdown'
import { getBreakdownColumnName } from 'pages/analytics/lib'
import { AnalyticMetricCell, BreakdownEntityCell } from 'pages/analytics/ui'

export const getColumns = (
  filterType: SearchTypesEnum | null
): IColumn<RowContactsComparison>[] => [
  {
    field: 'name',
    name: getBreakdownColumnName(filterType),
    fullName: getBreakdownColumnName(filterType),
    isDisabledChangeVisible: true,
    renderRowCell: (row) => {
      const { name, breakdownEntity } = row.fields

      return (
        <BreakdownEntityCell
          filterType={filterType}
          breakdownEntity={breakdownEntity}
          fallbackName={name}
        />
      )
    },
  },
  {
    field: 'new_contacts',
    name: 'New contacts',
    renderRowCell: (row) => {
      const { new_contacts } = row.fields

      return <AnalyticMetricCell value={new_contacts} />
    },
  },
  {
    field: 'opted_out',
    name: 'Opted-out contacts',
    renderRowCell: (row) => {
      const { opted_out } = row.fields

      return <AnalyticMetricCell value={opted_out} />
    },
  },
]
